import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBoxQuestionnaireContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeResumed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeEnded!: boolean;

  @jsonMember(Boolean)
  public readonly canBeSelectionChanged!: boolean;
}
